"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./Author"), exports);
__exportStar(require("./Blog"), exports);
__exportStar(require("./Book"), exports);
__exportStar(require("./Card"), exports);
__exportStar(require("./Chapter"), exports);
__exportStar(require("./Concept"), exports);
__exportStar(require("./Condition"), exports);
__exportStar(require("./Content"), exports);
__exportStar(require("./Difficulty"), exports);
__exportStar(require("./Feedback"), exports);
__exportStar(require("./File"), exports);
__exportStar(require("./Highlight"), exports);
__exportStar(require("./Invoice"), exports);
__exportStar(require("./Marksheet"), exports);
__exportStar(require("./MockTest"), exports);
__exportStar(require("./Note"), exports);
__exportStar(require("./Notification"), exports);
__exportStar(require("./OsceMarksheet"), exports);
__exportStar(require("./OsceStation"), exports);
__exportStar(require("./Paces"), exports);
__exportStar(require("./Picture"), exports);
__exportStar(require("./Presentation"), exports);
__exportStar(require("./Preset"), exports);
__exportStar(require("./Product"), exports);
__exportStar(require("./Promo"), exports);
__exportStar(require("./Psa"), exports);
__exportStar(require("./Question"), exports);
__exportStar(require("./Referrals"), exports);
__exportStar(require("./Subscription"), exports);
__exportStar(require("./Todo"), exports);
__exportStar(require("./Token"), exports);
__exportStar(require("./Topic"), exports);
__exportStar(require("./Type"), exports);
__exportStar(require("./Ucat"), exports);
__exportStar(require("./UkmlaTopic"), exports);
__exportStar(require("./University"), exports);
__exportStar(require("./User"), exports);
__exportStar(require("./UserSession"), exports);
__exportStar(require("./Video"), exports);
